export default __webpack_public_path__ + "static/media/discover-network.88d5208f.svg";